import { atom, useAtom } from 'jotai';

export const currentlyEditingUser = atom(undefined);

export function useCurrentlyEditingUserAtom() {
  return useAtom(currentlyEditingUser);
}
